import { render, staticRenderFns } from "./film.vue?vue&type=template&id=586e2d18&scoped=true"
import script from "./film.vue?vue&type=script&lang=js"
export * from "./film.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e2d18",
  null
  
)

export default component.exports